// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a36f0484","513":"4e53329a"}[chunkId] + ".chunk.js";
};